import { useCallback, useEffect, useState } from "react"
import { Template } from "../../Components/Template/template"
import {
    AlertType, classBorderLabelDark, classBt, classbtAzul, classbtCinzaClaro, classbtColunasAzul, classbtColunasVermelho, classBtSemDuration,
    classbtVerde, classbtVermelho, classDivBackground, classDivBody, classDivTitulo, classInput, classInputDark, classLabel, classLabelDark,
    classWeigthBt, Clientes, ClientesSearchBox, ContaAReceber
} from "../../Utils/Types"
import { FeedbackMessage } from "../../Components/FeedbackMessage/feedback-message"
import { HiDocumentDuplicate } from "react-icons/hi"
import { Link, useNavigate } from "react-router-dom"
import { Tooltip } from "react-tooltip"
import { FaTrash, FaVideo } from "react-icons/fa"
import { ClientesService } from "../Clientes/ClientesService"
import { SearchBox } from "../../Components/SearchBox/SearchBox"
import { IoAddCircleSharp, IoReceipt, IoSearch } from "react-icons/io5"
import { GridContaAReceber } from "../../Components/GridProducts/GridContaAReceber"
import { ContaAReceberService } from "./ContaAReceberService"
import { Funcoes } from "../../Utils/Funcoes"
import { ModalLiqDupReceber } from "../../Components/Modal/modal-liq-dup-receber"
import { ModalEstornarDupReceber } from "../../Components/Modal/modal-estorna-dup-receber"
import moment from "moment"
import { AiOutlineClear } from "react-icons/ai"
import { RelContaReceberGeralPDF } from "./pdf/rel-contaReceberGeral"
import { ModalTutorial } from "../../Components/Modal/modal-tutorial"

export const ContaAReceberPage = () => {

    let dateI = moment()
        .utcOffset('-03:00')
        .format('YYYY-MM-DD')

    let dateF = moment()
        .utcOffset('-03:00')
        .add(31, 'days')
        .format('YYYY-MM-DD')

    // ---------- ATRIBUTOS FEEDBACK -----------------
    const [loading, setLoading] = useState(false)
    const [visible, setVisible] = useState(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("SUCCESS")

    // ---------- ATRIBUTOS FILTRO -------------------
    const [clientes, setClientes] = useState<ClientesSearchBox[]>([])
    const [clientesList, setClientesList] = useState<ClientesSearchBox[]>([])
    const [idCliente, setIdCliente] = useState(0)

    const [datai, setDatai] = useState<string>(dateI)
    const [dataf, setDataf] = useState<string>(dateF)
    const [tipo_filtro, setTipo_Filtro] = useState("A")
    const [bordero, setBordero] = useState("")


    const [idSelect, setIdSelect] = useState(false)

    // ---------- ATRIBUTOS GRID ---------------------
    const [ctaReceberList, setCtaReceberList] = useState<ContaAReceber[]>([])

    // ------------- DADOS DUPLICATA -----------------
    const [qtdDup, setQtdDup] = useState(0)
    const [totDup, setTotDup] = useState(0)
    const [qtdDupSelecionado, setQtdDupSelecionado] = useState(0)
    const [totSelecionado, setTotSelecionado] = useState(0)
    const [totSelecionadoVisual, setTotSelecionadoVisual] = useState(0) // essa variavel só serve para mostrar os valores na tela sem atrapalhar a logica
    const [totJuros, setTotJuros] = useState(0)
    const [dupSelectedList, setDupSelectedList] = useState<number[]>([])
    const [borderoSelectedList, setBorderoSelectedList] = useState<number[]>([])
    const [selectDupAll, setSelectDupAll] = useState(false)

    // ------------- MODAL ---------------------------
    const [modalLiqDupVisible, setModalLiqDupVisible] = useState(false)
    const [modalCancelLiqVisible, setModalCancelLiqVisible] = useState(false)

    // ------------- SEARCH BOX ----------------------
    const [visibleSearchBoxCliente, setVisibleSearchBoxCliente] = useState<boolean>(false)

    // ---------- ATRIBUTOS TUTORIAL --------------------------------------------------
    const [modalTutorialVisible, setModalTutorialVisible] = useState(false)


    //------------------------------------------------------------- REQUISIÇÃO API, ATALHOS E FOCUS ----------------------------------------------------------------------------//
    const getClientes = async () => {
        setLoading(true)

        try {

            const resp = await ClientesService.GetListCliente()
            setClientes(resp.data)
            setClientesList(resp.data)

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar os clientes`)

        } finally {

            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 0)
        }
    }

    const calcularTotal = (ctaReceberList: ContaAReceber[], incluirValorOriginal: boolean = true) => {

        const hoje = new Date()
        const taxaPadrao = parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
        const dias = Number(localStorage.getItem("@ecommerce/diasJuros") || 0)
        let total = 0

        ctaReceberList.forEach(({ data_vencimento, valor_original }: any) => {
            const vencimentoBase = new Date(data_vencimento);

            // Soma os dias
            const vencimento = new Date(vencimentoBase);
            vencimento.setDate(vencimento.getDate() + 1 + dias);
            let juros = 0

            if (data_vencimento && vencimento < hoje) {
                const hojeZero = new Date(hoje)
                hojeZero.setHours(0, 0, 0, 0)

                const vencZero = new Date(vencimento)
                vencZero.setHours(0, 0, 0, 0)

                const diffTime = hojeZero.getTime() - vencZero.getTime()
                const diffDias = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0)

                if (diffDias > 0) {
                    const taxaPercent = taxaPadrao || 0        // ex.: 5 = 5% ao mês
                    const taxaDiaria = (taxaPercent / 100) / 30 // proporcional ao mês
                    juros = valor_original * taxaDiaria * diffDias // juros simples
                }
            }

            total += incluirValorOriginal ? (valor_original + juros) : juros

        })

        return parseFloat(total.toFixed(2))
    }

    const handleMouseUp = useCallback((e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        // Desfocar o link após o clique
        const target = e.target as HTMLElement
        if (target instanceof HTMLAnchorElement) {
            target.blur()
        }

    }, [])

    const handleKeyPressEnter = async (e: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDupRec") as HTMLDivElement

        if ((e.code === "Enter" || e.code === "NumpadEnter") && !modalLiqDupVisible && !modalCancelLiqVisible && !visibleSearchBoxCliente && !loading && menuFiltro.classList.contains("max-h-[1000px]")) {
            await handleFilterClick()
        }
    }

    const handleTabPress = (event: any) => {

        if (event.key === 'Tab') {
            event.preventDefault() // Evita o comportamento padrão do 'Tab'
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleTabPress)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleTabPress)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [datai, dataf, idCliente, tipo_filtro, bordero, modalLiqDupVisible, modalCancelLiqVisible, visibleSearchBoxCliente, loading])

    useEffect(() => {
        getClientes()
    }, [])

    useEffect(() => {
        //handleFilterClick()
        setCtaReceberList([])
        setBorderoSelectedList([])
        setSelectDupAll(false)
        setQtdDup(0)
        setTotDup(0)
        setTotSelecionado(0)
        setQtdDupSelecionado(0)
        setBordero("")
    }, [tipo_filtro])

    const searchBoxFocus = () => {
        setVisibleSearchBoxCliente(false)
    }

    const handleCloseMessage = () => {
        setVisible(false)
    }

    //--------------------------------------------------------------------------------------------- FILTROS ------------------------------------------------------------------------------------------//
    const handleFilterClick = async () => {

        setVisible(false)
        setLoading(true)

        setCtaReceberList([])
        setBorderoSelectedList([])
        setSelectDupAll(false)
        setQtdDup(0)
        setTotDup(0)
        setQtdDupSelecionado(0)
        setTotSelecionado(0)
        setTotSelecionadoVisual(0)
        setTotJuros(0)

        searchBoxFocus()

        try {

            //console.log("tipo_filtro: ", tipo_filtro)

            if (tipo_filtro == 'A') {

                const relatorio = {
                    id_cliente: idCliente,
                    datai: datai,
                    dataf: dataf,
                    tipo_filtro: tipo_filtro
                }

                const dados = await ContaAReceberService.Filter(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")

                } else {

                    setCtaReceberList(dados.data.ctaReceber)
                    setQtdDup(dados.data.qtdDup)

                    const total = calcularTotal(dados.data.ctaReceber, true)

                    setTotDup(total)

                    if (idCliente > 0) {
                        setIdSelect(true)
                    } else {
                        setIdSelect(false)
                    }

                }

            } else {

                const relatorio = {
                    datai: datai,
                    dataf: dataf,
                    id_cliente: idCliente,
                    bordero: bordero
                }

                const dados = await ContaAReceberService.FilterBordero(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")

                } else {

                    setCtaReceberList(dados.data.ctaReceber)
                    setQtdDup(dados.data.qtdDup)
                    setTotDup(dados.data.total)

                }
            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar as duplicatas`)

        } finally {
            setSelectDupAll(false)
            const timer = setTimeout(() => {
                setLoading(false)
                clearTimeout(timer)
            }, 1500)
        }

    }

    const filterDados = useCallback(async () => {

        setVisible(false)

        setCtaReceberList([])
        setBorderoSelectedList([])
        setSelectDupAll(false)
        setQtdDup(0)
        setTotDup(0)
        setQtdDupSelecionado(0)
        setTotSelecionado(0)
        setTotSelecionadoVisual(0)
        setTotJuros(0)

        try {

            if (tipo_filtro == 'A') {

                const relatorio = {
                    id_cliente: idCliente,
                    datai: datai,
                    dataf: dataf,
                    tipo_filtro: tipo_filtro
                }

                const dados = await ContaAReceberService.Filter(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")
                    setCtaReceberList([])
                    return false

                } else {

                    setCtaReceberList(dados.data.ctaReceber)
                    setQtdDup(dados.data.qtdDup)

                    const total = calcularTotal(dados.data.ctaReceber, true)

                    setTotDup(total)
                    return true
                }

            } else {

                const relatorio = {
                    datai: datai,
                    dataf: dataf,
                    id_cliente: idCliente,
                    bordero: bordero
                }

                const dados = await ContaAReceberService.FilterBordero(relatorio)

                if (dados.error) {

                    setVisible(true)
                    setMessageType("DANGER")
                    setMessage(dados.msg || "")
                    return false

                } else {

                    setCtaReceberList(dados.data.ctaReceber)
                    setQtdDup(dados.data.qtdDup)
                    setTotDup(dados.data.total)
                    return true

                }

            }

        } catch (error) {

            setVisible(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível buscar as duplicatas`)
            return false

        }

    }, [ctaReceberList, idCliente, datai, dataf, tipo_filtro, bordero])

    const handleLimparFiltros = () => {

        setIdCliente(0)
        setDatai(dateI)
        setDataf(dateF)
        setTipo_Filtro("A")
        setBordero("")

        setVisible(false)
        searchBoxFocus()
    }

    const toggleMenuFiltro = (event: any) => {

        let menuFiltro = document.getElementById("divMenuFiltroDupRec") as HTMLDivElement
        let menuInputs = document.getElementById("divInputsDupRec") as HTMLDivElement

        searchBoxFocus()

        if (menuFiltro) {

            menuFiltro.classList.toggle("max-h-[1000px]")
            menuFiltro.classList.toggle("max-h-[0px]")

            if (menuFiltro.classList.contains("max-h-[1000px]")) {

                menuInputs.classList.remove("invisible")

            } else {

                menuInputs.classList.add("invisible")

            }

            event.currentTarget.blur()
        }
    }

    const handleChangeDtInicio = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDatai(e.target.value)
    }

    const handleChangeDtFim = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataf(e.target.value)
    }

    const handleChangeTipoFiltro = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setTipo_Filtro(e.target.value)
    }

    const handleChangeBordero = (e: React.ChangeEvent<HTMLInputElement>) => {
        setBordero(e.target.value.replace(/[^0-9]/g, ''))
    }

    //-------------------------------------------------------------------- PDF ---------------------------------------------------------------------------------------//
    /* // caso seja necessario ter o botao de imprimir aqui voltar com esse codigo
    const handleGerarPDFClick = async (event: any) => {
        try {

            const pdf = new RelContaReceberGeralPDF(ctaReceberList, totalDuplicatas, totalValor)
            pdf.GerarPDF(ctaReceberList)

            event.currentTarget.blur()

        } catch (error) {

            setVisible(true)
            setMessageType('DANGER')
            setMessage(`Ocorreu um erro ao imprimir. Por favor, tente novamente`)
        }

    }
    */

    //--------------------------------------------------------------------------------------------- CLIENTE ------------------------------------------------------------------------------------------//
    const handleClearClienteSelecionado = useCallback(() => {
        const newClienteList = [...clientes || []]
        setClientesList(newClienteList)
        setIdCliente(0)

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const handleFilterClienteClick = useCallback(async (description: string) => {

        if (description === "") {

            const newClienteList = [...clientes || []]
            setClientesList(newClienteList || [])

        } else {

            const newClienteList = [...clientes || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setClientesList(newClienteList || [])
        }

    }, [clientes])

    const handleClienteSelectClick = useCallback(async (v: Clientes) => {

        if (v) {
            const newClienteList = [...clientes || []]
            setClientesList(newClienteList)
            setIdCliente(v.id)
        }

        setVisibleSearchBoxCliente(false)

    }, [clientes])

    const clickSearchBoxCliente = useCallback(() => {
        setVisibleSearchBoxCliente((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                inputFocusCliente()
            }
            return newState
        })
    }, [])

    const inputFocusCliente = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cliente`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    //--------------------------------------------------------------------------------------------- FUNÇÕES GRID ------------------------------------------------------------------------------------------//
    const handleColumnLiqClick = useCallback(() => {

        let newCtaReceberList = [...ctaReceberList]
        newCtaReceberList = [...ctaReceberList]
        let total = 0
        let totalJuros = 0

        for (let i in newCtaReceberList) {
            newCtaReceberList[i].selected = !selectDupAll
            total += newCtaReceberList[i].valor
        }

        totalJuros = calcularTotal(newCtaReceberList, false)

        if (selectDupAll) {
            setTotJuros(0)
            setTotSelecionado(0)
            setTotSelecionadoVisual(0)
        } else {
            setTotJuros(totalJuros)
            setTotSelecionado(total)
            setTotSelecionadoVisual(total + totalJuros)
        }

        setCtaReceberList(newCtaReceberList)
        setSelectDupAll(!selectDupAll)

    }, [ctaReceberList, selectDupAll])

    const handleCheckBoxClick = useCallback(async (id: number, selected: boolean, taxa: number) => {

        const newCtaReceberList = [...ctaReceberList]
        const index = newCtaReceberList.findIndex((item) => item.id === id)

        if (index >= 0) {

            newCtaReceberList[index].selected = !selected
            const itemSelecionado = newCtaReceberList[index]

            setCtaReceberList(newCtaReceberList)

            setTotSelecionado((prevTotal) => {
                let newTotal = prevTotal
                let valor = itemSelecionado.valor

                if (!selected) {
                    newTotal += valor
                } else {
                    newTotal -= valor
                }
                //console.log("newTotal.toFixed(2): ", newTotal.toFixed(2))

                return parseFloat(newTotal.toFixed(2))
            })

            setQtdDupSelecionado((prevTotal) => {
                let newTotal = prevTotal
                let valor = itemSelecionado?.qtdDup || 0

                if (!selected) {
                    newTotal += valor
                } else {
                    newTotal -= valor
                }

                return newTotal
            })

            const hoje = new Date()
            const dias = Number(localStorage.getItem("@ecommerce/diasJuros") || 0)

            // Soma dias à data de vencimento
            const vencimentoBase = new Date(newCtaReceberList[index].data_vencimento);
            const vencimento = new Date(vencimentoBase);
            vencimento.setDate(vencimento.getDate() + 1 + dias);

            setTotJuros((prevTotal) => {
                let newTotal = prevTotal

                const taxa = (newCtaReceberList[index].data_vencimento && vencimento < hoje)
                    ? parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
                    : 0

                let valor = newCtaReceberList[index].valor
                let valorComJuros = 0

                const hojeZero = new Date(hoje)
                hojeZero.setHours(0, 0, 0, 0)
                const vencZero = new Date(vencimento)
                vencZero.setHours(0, 0, 0, 0)

                const diffTime = hojeZero.getTime() - vencZero.getTime()
                const diffDias = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0)

                if (diffDias > 0) {
                    const taxaPercent = taxa || 0            // ex.: 5 = 5% ao mês
                    const taxaDiaria = (taxaPercent / 100) / 30 // proporcional ao mês
                    const juros = valor * taxaDiaria * diffDias // juros simples
                    valorComJuros = juros
                }

                if (!selected) {
                    newTotal += valorComJuros
                } else {
                    newTotal -= valorComJuros
                }

                // Arredonda para 2 casas decimais e garante que seja número
                return parseFloat(newTotal.toFixed(2))
            })

            setTotSelecionadoVisual((prevTotal) => {
                let newTotal = prevTotal

                const taxa = (newCtaReceberList[index].data_vencimento && vencimento < hoje)
                    ? parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
                    : 0

                let valor = newCtaReceberList[index].valor
                let valorComJuros = 0

                const hojeZero = new Date(hoje)
                hojeZero.setHours(0, 0, 0, 0)
                const vencZero = new Date(vencimento)
                vencZero.setHours(0, 0, 0, 0)

                const diffTime = hojeZero.getTime() - vencZero.getTime()
                const diffDias = Math.max(Math.floor(diffTime / (1000 * 60 * 60 * 24)), 0)

                if (diffDias > 0) {
                    const taxaPercent = taxa || 0           // ex.: 5 = 5% ao mês
                    const taxaDiaria = (taxaPercent / 100) / 30 // proporcional ao mês
                    const juros = valor * taxaDiaria * diffDias // juros simples
                    valorComJuros = valor + juros
                } else {
                    valorComJuros = valor
                }

                if (!selected) {
                    newTotal += valorComJuros
                } else {
                    newTotal -= valorComJuros
                }

                // Arredonda para 2 casas decimais e garante que seja número
                return parseFloat(newTotal.toFixed(2))
            })

        }

    }, [ctaReceberList])

    const handlerOpenModalLiqDup = () => {

        setVisible(false)
        searchBoxFocus()

        let newCtaReceberList = [...ctaReceberList]
        newCtaReceberList = newCtaReceberList.filter((item) => item.selected === true)
        const newCtaSelectedList: number[] = []

        if (newCtaReceberList.length === 0) {
            const timer = setTimeout(() => {
                setVisible(true)
                setMessageType("DANGER")
                setMessage(`Nenhuma duplicata selecionada`)
                clearTimeout(timer)
            }, 0)
            return
        }

        newCtaReceberList.map((item) => newCtaSelectedList.push(item.id))
        setDupSelectedList(newCtaSelectedList || [])
        setModalLiqDupVisible(true)
    }

    const handlerOpenModalEstornarLiq = async () => {

        setVisible(false)
        searchBoxFocus()

        let newCtaReceberList = [...ctaReceberList]

        newCtaReceberList = newCtaReceberList.filter((item) => item.selected === true)
        const newCtaSelectedList: number[] = []
        const newBorderoList: number[] = []

        newCtaReceberList.map((item) => newCtaSelectedList.push(item.id))
        newCtaReceberList.map((item) => newBorderoList.push(item.id_bordero || 0))

        setDupSelectedList(newCtaSelectedList || [])
        setBorderoSelectedList(newBorderoList)
        setModalCancelLiqVisible(true)
    }

    const fecharModalLiqDupReceber = useCallback(() => {
        setModalLiqDupVisible(false)
    }, [])

    const fecharModalEstornarDupReceber = useCallback(() => {
        setModalCancelLiqVisible(false)
    }, [])

    // ----------------------------------------------------------- NAVEGAÇÃO ------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaContaAReceber = () => {
        //navigate("/contaAreceber/new")
    }

    return (

        <Template isLoading={loading}>

            <div className={`${classDivBackground}`}>

                <div role='button' id="div-body" className={`${classDivBody}`}>

                    <FeedbackMessage visible={visible} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                    <div className={`${classDivTitulo} grid grid-cols-12 gap-4 p-2`}>

                        <div className={`relative col-span-12 sm:col-span-8 2xl:col-span-5 flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0`}>

                            <div className="flex flex-row">
                                <HiDocumentDuplicate className={`mr-2 ml-2 text-slate-700 dark:text-slate-200`} size="25px" />
                                <span className={`text-base md:text-lg xl:text-2xl text-slate-700 dark:text-slate-200`}>Duplicatas a Receber</span>
                            </div>

                            <button onClick={() => { setModalTutorialVisible(true) }} tabIndex={-1} disabled={loading} className={`${classBt} ${classbtAzul} ${classWeigthBt} h-9 shadow-md shadow-blue-600 mx-2`}  >
                                <FaVideo />
                                <span className='mx-1'>Tutorial</span>
                            </button>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-2 2xl:col-span-1`}>
                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/contaAreceber/excluidos'} data-tooltip-id={'tooltip-btn-lixeira'} id={'btn-lixeira'} className={`${classbtColunasVermelho} h-9`} >
                                <FaTrash size="25px" />
                            </Link>
                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-btn-lixeira'}
                                anchorSelect={'#btn-lixeira'} positionStrategy="fixed" place='left' >
                                <span>Duplicatas Excluídas</span>
                            </Tooltip>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-2 2xl:col-span-1`}>
                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/contaAreceber/recibos'} data-tooltip-id={'tooltip-btn-recibo'} id={'btn-recibo'} className={`${classbtColunasAzul} h-9`} >
                                <IoReceipt size="25px" />
                            </Link>
                            <Tooltip style={{ backgroundColor: 'rgb(210, 200, 95)' }} id={'tooltip-btn-recibo'}
                                anchorSelect={'#btn-recibo'} positionStrategy="fixed" place='left' >
                                <span>Recibos</span>
                            </Tooltip>
                        </div>

                        <div className={`relative col-span-6 sm:col-span-4 2xl:col-span-1`}>
                            <button tabIndex={-1} className={`${classbtColunasAzul} h-9`} onClick={toggleMenuFiltro} >
                                <span className={`w-full h-full flex justify-center items-center`}>Filtros</span>
                            </button>
                        </div>

                        {/*
                        <div className={`relative col-span-6 sm:col-span-3 2xl:col-span-1 hidden`}>
                            <button tabIndex={-1} className={`${classBtSemDuration} ${classbtCeuAzul} h-9 disabled:opacity-50 disabled:cursor-not-allowed`} disabled={!(ctaReceberList.length > 0) || !(tipo_filtro === 'A')} onClick={handleGerarPDFClick}>
                                <IoPrint size="25px" className={`mr-2 hidden md:block`} /> Imprimir
                            </button>
                        </div>
                        */}

                        <div className={`relative col-span-6 sm:col-span-4 2xl:col-span-2`}>
                            {tipo_filtro === "A" &&
                                <button tabIndex={-1} className={` ${classBt} ${classbtAzul} w-full disabled:opacity-50 disabled:cursor-not-allowed h-9`} disabled={totSelecionado > 0 ? false : true} onClick={handlerOpenModalLiqDup}>
                                    {/*
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        <FaDownload className={`mr-2 hidden md:block`} /> <span >Liquidar duplicatas</span>
                                    </span>
                                    */}

                                    <span >Liquidar duplicatas</span>
                                </button>
                            }

                            {tipo_filtro === "L" &&
                                <button tabIndex={-1} className={`${classBt} ${classbtVermelho} w-full disabled:opacity-50 disabled:cursor-not-allowed h-9`} disabled={totSelecionado > 0 ? false : true} onClick={handlerOpenModalEstornarLiq}>
                                    {/*
                                    <span className={`w-full h-full flex justify-center items-center`}>
                                        <img src={estornoClaro} alt="Estorno" className="items-center justify-center hidden w-6 h-6 mx-1 md:block" /><span className='mx-1'>Estornar Duplicatas</span>
                                    </span>
                                    */}
                                    <span className='mx-1'>Estornar Duplicatas</span>
                                </button>
                            }
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 2xl:col-span-2`}>

                            <Link tabIndex={-1} onMouseUp={handleMouseUp} to={'/contaAreceber/new'} className={`${classBtSemDuration} ${classbtVerde} h-9`} >
                                <IoAddCircleSharp className={`mx-2 hidden md:block`} size="20px" /> Cadastro
                            </Link>

                            {/*
                            <button tabIndex={-1} onClick={navegarTelaContaAReceber} className={`${classbtVerde} ${classBt} h-9`}>
                                <IoAddCircleSharp size="20px" className={`mr-2 hidden md:block`} /> Cadastro
                            </button>
                            */}

                        </div>

                    </div>

                    <div id='divInputsDupRec' className={`relative invisible ease-in-out duration-[150ms]`}>

                        <div id='divMenuFiltroDupRec' className={`relative max-h-[0px] h-[600px] sm:h-[390px] md:h-[340px] xl:h-[280px] 2xl:h-[210px] cursor-default bg-white dark:bg-slate-600 shadow-sm shadow-slate-400 dark:shadow-slate-800 border dark:border-slate-800 rounded-md overflow-y-hidden`} style={{ transitionDuration: "0ms, 300ms", transitionProperty: "background-color, max-height" }} />

                        <div className={`absolute top-0 w-full h-auto grid grid-cols-12 gap-3 py-4 px-3`}>

                            <div className={`relative col-span-12 xl:col-span-6 2xl:col-span-4 mt-2`}>
                                <SearchBox
                                    dataList={clientesList}
                                    idRegistro={idCliente || undefined}
                                    label='Cliente'
                                    componentId='cliente'
                                    visibleTAB={visibleSearchBoxCliente}
                                    clearDataClick={handleClearClienteSelecionado}
                                    setDataClick={handleClienteSelectClick}
                                    filterDataClick={handleFilterClienteClick}
                                    clicado={clickSearchBoxCliente}
                                />

                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="dt_inicial_dupReceber" className={`${classInput} ${classInputDark} ${datai === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={datai} onFocus={searchBoxFocus} onChange={handleChangeDtInicio} />
                                <label htmlFor="dt_inicial_dupReceber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipo_filtro === 'A' ? 'Data de Vencimento Inicial' : 'Data da Baixa Inicial'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="dt_final_dupReceber" className={`${classInput} ${classInputDark} ${dataf === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark] `} type='date' min="1900-01-01" max="9999-12-31" placeholder=' ' value={dataf} onFocus={searchBoxFocus} onChange={handleChangeDtFim} />
                                <label htmlFor="dt_final_dupReceber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>{tipo_filtro === 'A' ? 'Data de Vencimento Final' : 'Data da Baixa Final'}</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <select id="status_dupReceber" className={`${classInput} ${classInputDark} `} value={tipo_filtro} onFocus={searchBoxFocus} onChange={handleChangeTipoFiltro}>
                                    <option value="A" className={`text-slate-900 dark:text-slate-200`}>Abertas</option>
                                    <option value="L" className={`text-slate-900 dark:text-slate-200`}>Liquidadas</option>
                                </select>
                                <label htmlFor="status_dupReceber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Status</label>
                            </div>

                            <div className={`relative col-span-12 sm:col-span-4 xl:col-span-3 2xl:col-span-2 mt-2`}>
                                <input id="bordero_dupReceber" className={`${classInput} ${classInputDark} `} type='text' inputMode="numeric" placeholder=' ' autoComplete='off' value={bordero} disabled={loading || tipo_filtro === "A"} onFocus={searchBoxFocus} onChange={handleChangeBordero} />
                                <label htmlFor="bordero_dupReceber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Borderô</label>
                            </div>

                            <div className={`col-span-12 flex flex-col sm:flex-row justify-end sm:space-x-2 mt-3`}>

                                <div className={`relative mt-2 sm:mt-0`}>
                                    <button className={`${classBtSemDuration} ${classbtCinzaClaro} w-full sm:min-w-[150px]`} onClick={handleLimparFiltros}>
                                        <AiOutlineClear size="20px" className={`mr-[2px]`} /><span className='mx-1'>Limpar Campos</span>
                                    </button>
                                </div>

                                <div className={`relative mt-6 sm:mt-0`}>
                                    <button tabIndex={-1} disabled={loading} className={`${loading ? `opacity-40` : ``} ${classbtColunasAzul} w-full sm:min-w-[150px]`} onFocus={searchBoxFocus} onClick={handleFilterClick} >
                                        <span className={`w-full h-full flex justify-center items-center`}>
                                            {!loading && <IoSearch size="20px" className={`mr-2`} />}
                                            {loading &&
                                                <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-[#2980b9] dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                            {!loading && `Pesquisar`} {loading && `Aguarde`}
                                        </span>
                                    </button>
                                </div>

                            </div>

                            <div className={`col-span-12`}>

                                <div className={`flex flex-col md:flex-row md:py-2 justify-start w-full h-auto border border-slate-500 rounded-md bg-gray-200 dark:bg-slate-700`}>

                                    <div className={`w-full md:w-[25%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>N° Duplicatas: </span>
                                        <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{qtdDup}</span>
                                    </div>

                                    <div className={`w-full md:w-[35%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row border md:border-none border-x-0 border-t-0 dark:border-slate-500 border-slate-400`}>
                                        <span className={`w-full md:w-auto`}>Total: </span>
                                        <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totDup, 'currency')}</span>
                                    </div>

                                    <div className={`w-full md:w-[40%] font-mono py-1 px-2 dark:text-slate-200 flex flex-row `}>
                                        <span className={`w-full md:w-auto`}>Total Selecionado: </span>
                                        <span className={`w-full md:w-auto flex justify-end items-center md:ml-2`}>{Funcoes.numberFormat(totSelecionadoVisual, 'currency')}</span>
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <div className={`w-full cursor-default mt-1 z-0 border shadow-sm shadow-slate-400 dark:bg-slate-600 dark:border-slate-800 dark:shadow-slate-800`}>

                        <GridContaAReceber
                            duplicata={ctaReceberList}
                            tipo={tipo_filtro === "L" ? "L" : "A"}
                            selectedAll={selectDupAll}
                            handleColumnLiqClick={handleColumnLiqClick}
                            handleSelectItemClick={handleCheckBoxClick}
                            handleUpdateDuplicataList={filterDados}
                            id_select={idSelect}
                        />

                    </div>

                </div>

                <ModalLiqDupReceber
                    idCliente={idCliente}
                    visible={modalLiqDupVisible}
                    totSelecionado={totSelecionado}
                    totJuros={totJuros}
                    dupSelectedList={dupSelectedList}
                    tipo_baixa={dupSelectedList.length > 0 ? "D" : "V"}
                    handleConfirm={filterDados}
                    handleModalClose={fecharModalLiqDupReceber}
                />

                <ModalEstornarDupReceber
                    visible={modalCancelLiqVisible}
                    totSelecionado={totSelecionado}
                    qtdDupSelecionado={qtdDupSelecionado}
                    dupSelectedList={dupSelectedList}
                    bordero={borderoSelectedList}
                    handleModalClose={fecharModalEstornarDupReceber}
                    handleConfirm={filterDados}

                />

                {modalTutorialVisible &&
                    <ModalTutorial
                        linkVideo='/tutorial_dupReceber.mp4'
                        title='Tutorial sobre duplicatas a receber'
                        visible={modalTutorialVisible}
                        onCloseClick={() => setModalTutorialVisible(false)}
                    />
                }

            </div>

        </Template>

    )
}